import React, { useState } from 'react';
import { BLOG_UPLOAD_GUIDE } from '../../../constants/blog';
import styles from './BlogHelpPanel.module.css';

// Instructivo desplegable con la guía detallada de carga del blog.
const BlogHelpPanel = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.panel}>
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span>📘 ¿Cómo cargar una publicación? (instructivo)</span>
        <span className={styles.chevron}>{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div className={styles.content}>
          {BLOG_UPLOAD_GUIDE.map((section) => (
            <div key={section.title} className={styles.section}>
              <h4 className={styles.sectionTitle}>{section.title}</h4>
              <ul className={styles.list}>
                {section.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
          <p className={styles.note}>
            Recordá: el título es lo único obligatorio. El resto de los campos y
            archivos son opcionales.
          </p>
        </div>
      )}
    </div>
  );
};

export default BlogHelpPanel;
